module.exports = __webpack_public_path__ + "img/bgProClass.d08b821b.jpg";